document.addEventListener("DOMContentLoaded", () => {
  const countryDropdown = document.getElementById("country-dropdown");
  const localeDropdown = document.getElementById("locale-dropdown");
  const enterBtn = document.getElementById("enter-btn");
  const disclosureButton = document.querySelector(
    "#disclosure__button_desktop"
  );
  const disclosureMobileButton = document.querySelector(
    "#disclosure__button_mobile"
  );

  const countryNamesInEnglish = {
    BE: "Belgique",
    IT: "Italia",
    FR: "France",
    DE: "Deutschland",
    AT: "Österreich",
    LU: "Luxembourg",
    ES: "Spain",
    NL: "Netherlands",
  };

  document
    .querySelectorAll("#country-dropdown .splash-dropdown-option")
    .forEach((option) => {
      const code = option.dataset.value;
      const img = option.querySelector("img"); // flag
      if (countryNamesInEnglish[code]) {
        // rimuoviamo eventuale testo esistente e aggiungiamo nuovo testo
        const textNode = document.createTextNode(countryNamesInEnglish[code]);
        // rimuoviamo eventuali nodi di testo preesistenti
        option.childNodes.forEach((n) => {
          if (n.nodeType === Node.TEXT_NODE) option.removeChild(n);
        });
        option.appendChild(textNode);
      }
    });

  /*if (!localStorage.getItem("countryLanguageChosen")) {
    const splash = document.getElementById("splash-modal");
    if (splash) splash.style.display = "flex";
  }*/

  if (enterBtn) {
    enterBtn.addEventListener("click", () => {
      localStorage.setItem("countryLanguageChosen", "true");
      // set country and lang
      localStorage.setItem("selectedLocalization", selectedLocale);
    });
  }

  if (disclosureButton) {
    disclosureButton.addEventListener("click", function () {
      localStorage.removeItem("countryLanguageChosen");
      const splash = document.getElementById("splash-modal");
      if (splash) splash.style.display = "flex";
    });
  }

  if (disclosureMobileButton) {
    disclosureMobileButton.addEventListener("click", function () {
      localStorage.removeItem("countryLanguageChosen");
      const splash = document.getElementById("splash-modal");
      if (splash) splash.style.display = "flex";
    });
  }

  const countryLocales = {
    BE: ["fr-be", "nl-be"],
    IT: ["it-it"],
    FR: ["fr-fr"],
    DE: ["de-de"],
    AT: ["de-at"],
    LU: ["fr-lu"],
    ES: ["es-es"],
    NL: ["nl-nl"],
  };

  const localeNames = {
    "fr-be": "Français",
    "nl-be": "Nederlands",
    "de-de": "Deutsch",
    "it-it": "Italiano",
    "fr-fr": "Français",
    "de-at": "Deutsch",
    "fr-lu": "Français",
    "es-es": "Español",
    "nl-nl": "Nederlands",
  };

  let selectedCountry = null;
  let selectedLocale = null;

  function setupOpenClose(dropdown) {
    const selected = dropdown.querySelector(".splash-dropdown-selected");
    const options = dropdown.querySelector(".splash-dropdown-options");
    selected.addEventListener("click", () => {
      if (dropdown.classList.contains("disabled")) return;
      dropdown.classList.toggle("open");
      options.style.display = dropdown.classList.contains("open")
        ? "block"
        : "none";
    });
  }

  document.addEventListener("click", (e) => {
    [countryDropdown, localeDropdown].forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove("open");
        dropdown.querySelector(".splash-dropdown-options").style.display =
          "none";
      }
    });
  });

  setupOpenClose(countryDropdown);
  setupOpenClose(localeDropdown);

  function loadLocalesForCountry(countryCode) {
    selectedCountry = countryCode;

    const locales = countryLocales[countryCode] || [];
    const localeOptions = localeDropdown.querySelector(
      ".splash-dropdown-options"
    );
    localeOptions.innerHTML = "";

    if (locales.length > 0) {
      if (locales.length === 1) {
        selectedLocale = locales[0];
        localeDropdown.querySelector(".splash-dropdown-value").textContent =
          localeNames[selectedLocale] || selectedLocale;

        localeDropdown.classList.add("disabled");
        localeDropdown.classList.remove("open");
        localeOptions.style.display = "none";

        localeDropdown.querySelector(".splash-dropdown-selected").style.cursor =
          "default";

        enterBtn.disabled = false;
      } else {
        locales.forEach((locale) => {
          const div = document.createElement("div");
          div.className = "splash-dropdown-option";
          div.dataset.value = locale;

          const langCode = locale.split("-")[0].toUpperCase();

          const img = document.createElement("img");
          img.src = window.flags[langCode.toLowerCase()];
          img.alt = `${localeNames[locale]} flag`;
          img.width = 20;
          img.height = 20;
          img.className = "splash-flag";

          div.appendChild(img);
          div.appendChild(
            document.createTextNode(" " + (localeNames[locale] || locale))
          );

          div.addEventListener("click", () => {
            selectedLocale = locale;
            localeDropdown.querySelector(".splash-dropdown-value").textContent =
              div.textContent;
            localeDropdown.classList.remove("open");
            localeOptions.style.display = "none";
            enterBtn.disabled = false;
          });

          localeOptions.appendChild(div);
        });

        selectedLocale = locales[0];
        localeDropdown.querySelector(".splash-dropdown-value").textContent =
          localeNames[selectedLocale] || selectedLocale;

        localeDropdown.classList.remove("disabled");
        enterBtn.disabled = false;
        localeDropdown.querySelector(".splash-dropdown-selected").style.cursor =
          "pointer";
      }
    } else {
      localeDropdown.classList.add("disabled");
      localeDropdown.querySelector(".splash-dropdown-value").textContent = "";
      localeOptions.style.display = "none";
      enterBtn.disabled = true;
    }
  }

  const defaultCountryCode = "IT";
  const defaultCountryOption = Array.from(
    countryDropdown.querySelectorAll(".splash-dropdown-option")
  ).find((opt) => opt.dataset.value === defaultCountryCode);

  if (defaultCountryOption) {
    selectedCountry = defaultCountryCode;
    countryDropdown.querySelector(".splash-dropdown-value").textContent =
      defaultCountryOption.textContent;
    loadLocalesForCountry(selectedCountry);
  } else {
    const firstCountryOption = countryDropdown.querySelector(
      ".splash-dropdown-option"
    );
    if (firstCountryOption) {
      selectedCountry = firstCountryOption.dataset.value;
      countryDropdown.querySelector(".splash-dropdown-value").textContent =
        firstCountryOption.textContent;
      loadLocalesForCountry(selectedCountry);
    }
  }

  countryDropdown
    .querySelectorAll(".splash-dropdown-option")
    .forEach((option) => {
      option.addEventListener("click", () => {
        countryDropdown.querySelector(".splash-dropdown-value").textContent =
          option.textContent;
        countryDropdown.classList.remove("open");
        countryDropdown.querySelector(
          ".splash-dropdown-options"
        ).style.display = "none";

        loadLocalesForCountry(option.dataset.value);
      });
    });

  enterBtn.addEventListener("click", () => {
    if (selectedLocale) {
      window.location.href = "/" + selectedLocale;
    }
  });
});
